<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" v-bind:href="'#t1'+rowData.regfis_id+''" role="tab" data-toggle="tab">
						<span class="nav-link-in">
							Detalhes
							<i class="fa fa-bulding"></i>
						</span>
					</a>
				</li>
                <li class="nav-item" v-if="rowData.regra_fiscal_cliente.length>0">
                  <a class="nav-link" v-bind:href="'#t2'+rowData.regfis_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Cliente
                      <i class="fa fa-bulding"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item" v-if="rowData.regra_fiscal_transportador.length>0">
                  <a class="nav-link" v-bind:href="'#t10'+rowData.regfis_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Transportador
                      <i class="fa fa-bulding"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item" v-if="rowData.regra_fiscal_doc.length>0">
                  <a class="nav-link" v-bind:href="'#t3'+rowData.regfis_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Documentos
                      <i class="fa fa-bulding"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item" v-if="rowData.regra_fiscal_uf_origem.length>0">
                  <a class="nav-link" v-bind:href="'#t4'+rowData.regfis_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      UF Origem
                      <i class="fa fa-bulding"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item" v-if="rowData.regra_fiscal_uf_destino.length>0">
                  <a class="nav-link" v-bind:href="'#t5'+rowData.regfis_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      UF Destino
                      <i class="fa fa-bulding"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item" v-if="rowData.regra_fiscal_uf_tomador.length>0">
                  <a class="nav-link" v-bind:href="'#t6'+rowData.regfis_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      UF Tomador
                      <i class="fa fa-bulding"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item" v-if="rowData.regra_fiscal_modal.length>0">
                  <a class="nav-link" v-bind:href="'#t7'+rowData.regfis_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Modal
                      <i class="fa fa-bulding"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item" v-if="rowData.regra_fiscal_unidade.length>0">
                  <a class="nav-link" v-bind:href="'#t8'+rowData.regfis_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Unidade
                      <i class="fa fa-bulding"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item" v-if="rowData.regra_fiscal_tp_servico.length>0">
                  <a class="nav-link" v-bind:href="'#t9'+rowData.regfis_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Tipo serviço
                      <i class="fa fa-bulding"></i>
                    </span>
                  </a>
                </li>
			</ul>

			<div class="tab-content">
				<div role="tabpanel" class="tab-pane fade in active show" v-bind:id="'t1'+rowData.regfis_id+''">
                        <table class="table" id="mais">
                            <thead>
                                <tr>
                                    <th v-if="rowData.obs!==null" style="width: 20%">Observação</th>
                                    <th v-if="rowData.ind_ie_est!==null" style="width: 15%">Indicador IE EST</th>
                                    <th v-if="rowData.ind_tomador!==null" style="width: 10%">Indicador Tomador</th>
                                    <th v-if="rowData.ind_tp_calculo!==null" style="width: 15%">Indicador Tipo cálculo</th>
                                    <th v-if="rowData.ind_automatica!==null" style="width: 10%">Indicador Automática</th>
                                    <th v-if="rowData.nop!==null" style="width: 15%">NOP</th>
                                    <th style="width: 5%">Aplicação</th>
                                    <th style="width: 5%">Alíquota</th>
                                    <th style="width: 5%">Percentual Redução BC</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr class="bg-gray-light" style="display: table-row;">
                                    <td  v-if="rowData.obs!==null">
                                        {{ rowData.obs }}
                                    </td>
                                    <td v-if="rowData.ind_ie_est!==null">
                                        {{ rowData.ind_ie_est.descr }}
                                    </td>
                                    <td v-if="rowData.ind_tomador!==null">
                                        {{ rowData.ind_tomador.descr }}
                                    </td>
                                    <td v-if="rowData.ind_tp_calculo!==null">
                                        {{ rowData.ind_tp_calculo.descr }}
                                    </td>
                                    <td v-if="rowData.ind_automatica!==null">
                                        {{ rowData.ind_automatica.descr }}
                                    </td>
                                    <td v-if="rowData.nop!==null">
                                        {{ rowData.nop }}
                                    </td>
                                    <td>
                                        {{ rowData.descr_aplicacao }}
                                    </td>
                                    <td>
                                        {{ rowData.aliquota }}
                                    </td>
                                    <td>
                                        {{ rowData.perc_red_base_calc }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade" v-bind:id="'t2'+rowData.regfis_id+''" v-if="rowData.regra_fiscal_cliente.length>0">
                    <table class="table" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 5%">Código</th>
                                <th style="width: 20%">Tipo Pessoa</th>
                                <th style="width: 20%">CNPJ/CPF</th>
                                <th style="width: 30%">Razão Social/Nome</th>
                                <th style="width: 10%">Observação</th>
                                <th style="width: 5%">Automático</th>
                                <th style="width: 5%">Status</th>
                                <th style="width: 5%">Ações</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.regra_fiscal_cliente">
                                <td>
                                    {{ item.pessoa.cd }}
                                </td>
                                <td>
                                    {{ item.pessoa.liv_tipo_pessoa.descr }}
                                </td>
                                <td>
                                   <span v-if="item.pessoa.pessoa_juridica!==null">{{ onFormataCnpj(item.pessoa.pessoa_juridica.cnpj_base,item.pessoa.pessoa_juridica.cnpj_filial,item.pessoa.pessoa_juridica.cnpj_digito)}}</span>
                                   <span v-if="item.pessoa.pessoa_exterior!==null">{{ item.pessoa.pessoa_exterior.cuit }}</span>
                                   <span v-if="item.pessoa.pessoa_fisica!==null">{{ item.pessoa.pessoa_fisica.cpf }}</span>
                                </td>
                                <td>
                                   <span v-if="item.pessoa.pessoa_juridica!==null">{{ item.pessoa.pessoa_juridica.razao_social }}</span>
                                   <span v-if="item.pessoa.pessoa_exterior!==null">{{ item.pessoa.pessoa_exterior.nome }}</span>
                                   <span v-if="item.pessoa.pessoa_fisica!==null">{{ item.pessoa.pessoa_fisica.nome }}</span>
                                </td>
                                <td>
                                    {{ item.obs }}
                                </td>
                                <td>
                                    {{ item.automatico.descr }}
                                </td>
                                <td>
                                    <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                    <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                </td>
                                <td>
                                    <a v-if="item.status.valor==2" @click="onActivateDesactivateCliente(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                    <a v-if="item.status.valor==1" @click="onActivateDesactivateCliente(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                    <a @click="onEditCliente(item)" v-b-tooltip title="Alterar"><i class="fa fa-edit"></i></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade" v-bind:id="'t3'+rowData.regfis_id+''" v-if="rowData.regra_fiscal_doc.length>0">
                    <table class="table" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 10%">Código</th>
                                <th style="width: 70%">Descrição</th>
                                <th style="width: 10%">Status</th>
                                <th style="width: 10%">Ações</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.regra_fiscal_doc">
                                <td>
                                    {{ item.param_tipo_doc.sigla }}
                                </td>
                                <td>
                                    {{ item.param_tipo_doc.descr }}
                                </td>
                                <td>
                                <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                              </td>
                              <td>
                                  <a v-if="item.status.valor==2" @click="onActivateDesactivateDoc(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                  <a v-if="item.status.valor==1" @click="onActivateDesactivateDoc(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                              </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
                        <div role="tabpanel" class="tab-pane fade" v-bind:id="'t4'+rowData.regfis_id+''" v-if="rowData.regra_fiscal_uf_origem.length>0">
                            <table class="table" id="mais">
                                <thead>
                                    <tr>
                                        <th style="width: 10%">Código</th>
                                        <th style="width: 10%">Código IBGE</th>
                                        <th style="width: 60%">Nome</th>
                                        <th style="width: 10%">Status</th>
                                        <th style="width: 10%">Ações</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                     <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.regra_fiscal_uf_origem">
                                        <td>
                                            {{ item.uf.cd }}
                                        </td>
                                        <td>
                                            {{ item.uf.cd_ibge }}
                                        </td>
                                        <td>
                                            {{ item.uf.nome }}
                                        </td>
                                        <td>
                                        <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                        <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                      </td>
                                      <td>
                                          <a v-if="item.status.valor==2" @click="onActivateDesactivateUfOrigem(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                          <a v-if="item.status.valor==1" @click="onActivateDesactivateUfOrigem(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                      </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div><!--.tab-pane-->
                        <div role="tabpanel" class="tab-pane fade" v-bind:id="'t5'+rowData.regfis_id+''" v-if="rowData.regra_fiscal_uf_destino.length>0">
                            <table class="table" id="mais">
                                <thead>
                                    <tr>
                                        <th style="width: 10%">Código</th>
                                        <th style="width: 10%">Código IBGE</th>
                                        <th style="width: 60%">Nome</th>
                                        <th style="width: 10%">Status</th>
                                        <th style="width: 10%">Ações</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                     <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.regra_fiscal_uf_destino">
                                        <td>
                                            {{ item.uf.cd }}
                                        </td>
                                        <td>
                                            {{ item.uf.cd_ibge }}
                                        </td>
                                        <td>
                                            {{ item.uf.nome }}
                                        </td>
                                        <td>
                                        <span class="badge badge-success" v-if="item.status != null && item.status.valor==1">{{ item.status.descr }}</span>
                                        <span class="badge badge-danger" v-if="item.status != null && item.status.valor==2">{{ item.status.descr }}</span>
                                      </td>
                                      <td>
                                          <a v-if="item.status != null && item.status.valor==2" @click="onActivateDesactivateUfDestino(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                          <a v-if="item.status != null && item.status.valor==1" @click="onActivateDesactivateUfDestino(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                      </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div><!--.tab-pane-->
                        <div role="tabpanel" class="tab-pane fade" v-bind:id="'t6'+rowData.regfis_id+''" v-if="rowData.regra_fiscal_uf_tomador.length>0">
                            <table class="table" id="mais">
                                <thead>
                                    <tr>
                                        <th style="width: 10%">Código</th>
                                        <th style="width: 10%">Código IBGE</th>
                                        <th style="width: 60%">Nome</th>
                                        <th style="width: 10%">Status</th>
                                        <th style="width: 10%">Ações</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                     <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.regra_fiscal_uf_tomador">
                                        <td>
                                            {{ item.uf.cd }}
                                        </td>
                                        <td>
                                            {{ item.uf.cd_ibge }}
                                        </td>
                                        <td>
                                            {{ item.uf.nome }}
                                        </td>
                                        <td>
                                        <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                        <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                      </td>
                                      <td>
                                          <a v-if="item.status.valor==2" @click="onActivateDesactivateUfTomador(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                          <a v-if="item.status.valor==1" @click="onActivateDesactivateUfTomador(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                      </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div><!--.tab-pane-->
                        <div role="tabpanel" class="tab-pane fade" v-bind:id="'t7'+rowData.regfis_id+''" v-if="rowData.regra_fiscal_modal.length>0">
                            <table class="table" id="mais">
                                <thead>
                                    <tr>
                                        <th style="width: 60%">Modal</th>
                                        <th style="width: 20%">Status</th>
                                        <th style="width: 20%">Ações</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                     <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.regra_fiscal_modal">
                                        <td>
                                            {{ item.b_modal.descr }}
                                        </td>
                                        <td>
                                           <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                           <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                        </td>
                                      <td>
                                          <a v-if="item.status.valor==2" @click="onActivateDesactivateModal(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                          <a v-if="item.status.valor==1" @click="onActivateDesactivateModal(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                      </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div><!--.tab-pane-->
                        <div role="tabpanel" class="tab-pane fade" v-bind:id="'t8'+rowData.regfis_id+''">
                            <table class="table" id="mais">
                                <thead>
                                    <tr>
                                        <th style="width: 60%">Unidade</th>
                                        <th style="width: 20%">Status</th>
                                        <th style="width: 20%">Ações</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                     <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.regra_fiscal_unidade">
                                        <td>
                                            {{ item.unidade.descr }}
                                        </td>
                                        <td>
                                           <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                           <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                        </td>
                                      <td>
                                          <a v-if="item.status.valor==2" @click="onActivateDesactivateUnidade(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                          <a v-if="item.status.valor==1" @click="onActivateDesactivateUnidade(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                      </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div><!--.tab-pane-->
                        <div role="tabpanel" class="tab-pane fade" v-bind:id="'t9'+rowData.regfis_id+''" v-if="rowData.regra_fiscal_tp_servico.length>0">
                            <table class="table" id="mais">
                                <thead>
                                    <tr>
                                        <th style="width: 60%">Tipo serviço</th>
                                        <th style="width: 20%">Status</th>
                                        <th style="width: 20%">Ações</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                     <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.regra_fiscal_tp_servico">
                                        <td>
                                            {{ item.param_tipo_servico.descr }}
                                        </td>
                                        <td>
                                           <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                           <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                        </td>
                                      <td>
                                          <a v-if="item.status.valor==2" @click="onActivateDesactivateTpServico(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                          <a v-if="item.status.valor==1" @click="onActivateDesactivateTpServico(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                      </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div><!--.tab-pane-->
                                        <div role="tabpanel" class="tab-pane fade" v-bind:id="'t10'+rowData.regfis_id+''" v-if="rowData.regra_fiscal_cliente.length>0">
                    <table class="table" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 5%">Código</th>
                                <th style="width: 20%">Tipo Pessoa</th>
                                <th style="width: 20%">CNPJ/CPF</th>
                                <th style="width: 30%">Razão Social/Nome</th>
                                <th style="width: 10%">Observação</th>
                                <th style="width: 5%">Automático</th>
                                <th style="width: 5%">Status</th>
                                <th style="width: 5%">Ações</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.regra_fiscal_transportador">
                                <td>
                                    {{ item.pessoa.cd }}
                                </td>
                                <td>
                                    {{ item.pessoa.liv_tipo_pessoa.descr }}
                                </td>
                                <td>
                                   <span v-if="item.pessoa.pessoa_juridica!==null">{{ onFormataCnpj(item.pessoa.pessoa_juridica.cnpj_base,item.pessoa.pessoa_juridica.cnpj_filial,item.pessoa.pessoa_juridica.cnpj_digito)}}</span>
                                   <span v-if="item.pessoa.pessoa_exterior!==null">{{ item.pessoa.pessoa_exterior.cuit }}</span>
                                   <span v-if="item.pessoa.pessoa_fisica!==null">{{ item.pessoa.pessoa_fisica.cpf }}</span>
                                </td>
                                <td>
                                   <span v-if="item.pessoa.pessoa_juridica!==null">{{ item.pessoa.pessoa_juridica.razao_social }}</span>
                                   <span v-if="item.pessoa.pessoa_exterior!==null">{{ item.pessoa.pessoa_exterior.nome }}</span>
                                   <span v-if="item.pessoa.pessoa_fisica!==null">{{ item.pessoa.pessoa_fisica.nome }}</span>
                                </td>
                                <td>
                                    {{ item.obs }}
                                </td>
                                <td>
                                    {{ item.automatico.descr }}
                                </td>
                                <td>
                                    <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                    <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                </td>
                                <td>
                                    <a v-if="item.status.valor==2" @click="onActivateDesactivateTransportador(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                    <a v-if="item.status.valor==1" @click="onActivateDesactivateTransportador(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                    <a @click="onEditTransportador(item)" v-b-tooltip title="Alterar"><i class="fa fa-edit"></i></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
			</div><!--.tab-content-->
            <RegraFiscalTransportadorForm ref="regrafiscaltransportadorform" />
		</div>
    </div>
  </template>

  <script>
import { formatCNPJFromParts } from "../utils";

      import RegraFiscalTransportadorForm from './RegraFiscalTransportadorForm.vue'
  export default {
    components: {
        RegraFiscalTransportadorForm
    },
      data () {
        return {
          helpForm: new Form({statusRecord: [], status: ''}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
        onEditCliente(data) {
            Event.$emit('editCliente', data);
        },
        onEditTransportador(data){
            this.$refs.regrafiscaltransportadorform.onEdit(data);
        },
                onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
          return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
        },
        onActivateDesactivateDoc(action, data, tipo) {
            // Tipo = true = Checkbox
            this.helpForm.status = action;
            if(tipo)
            {

                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.regfisdoc_id, status: action } );
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }
            this.helpForm.patch('/api/regrafiscaldoc/status').then(response =>
            {
                new ReturnApi(response, this);
                this.$events.fire('filter-reset');
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onActivateDesactivateUfOrigem(action, data, tipo) {
            // Tipo = true = Checkbox
            this.helpForm.status = action;
            if(tipo)
            {

                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.regfisufo_id , status: action } );
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }
            this.helpForm.patch('/api/regrafiscaluforigem/status').then(response =>
            {
                new ReturnApi(response, this);
                this.$events.fire('filter-reset');
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onActivateDesactivateUfDestino(action, data, tipo) {
            this.helpForm.status = action;
            if(tipo)
            {

                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.regfisufd_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }
            this.helpForm.patch('/api/regrafiscalufdestino/status').then(response =>
            {
                new ReturnApi(response, this);
                this.$events.fire('filter-reset');
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onActivateDesactivateUfTomador(action, data, tipo) {
            // Tipo = true = Checkbox
            this.helpForm.status = action;
            if(tipo)
            {

                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.regfisuft_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }

            this.helpForm.patch('/api/regrafiscaluftomador/status').then(response =>
            {
                new ReturnApi(response, this);
                this.$events.fire('filter-reset');
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onActivateDesactivateCliente(action, data, tipo) {
            // Tipo = true = Checkbox
            this.helpForm.status = action;
            if(tipo)
            {

                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.regfiscli_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }
            this.helpForm.patch('/api/regrafiscalcliente/status').then(response =>
            {
                new ReturnApi(response, this);
                this.$events.fire('filter-reset');
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onActivateDesactivateTransportador(action, data, tipo) {
            // Tipo = true = Checkbox
            this.helpForm.status = action;
            if(tipo)
            {

                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.regfistra_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }
            this.helpForm.patch('/api/regrafiscal/trasnportador/status').then(response =>
            {
                new ReturnApi(response, this);
                this.$events.fire('filter-reset');
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onActivateDesactivateModal(action, data, tipo) {
            // Tipo = true = Checkbox
            this.helpForm.status = action;
            if(tipo)
            {

                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.regfismod_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }
            this.helpForm.patch('/api/regrafiscalmodal/status').then(response =>
            {
                new ReturnApi(response, this);
                this.$events.fire('filter-reset');
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onActivateDesactivateUnidade(action, data, tipo) {
            // Tipo = true = Checkbox
            this.helpForm.status = action;
            if(tipo)
            {

                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.regfisuni_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }

            this.helpForm.patch('/api/regrafiscalunidade/status').then(response =>
            {
                new ReturnApi(response, this);
                this.$events.fire('filter-reset');
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onActivateDesactivateTpServico(action, data, tipo) {
            // Tipo = true = Checkbox
            this.helpForm.status = action;
            if(tipo)
            {

                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.regfistpserv_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }
            this.helpForm.patch('/api/regrafiscaltpservico/status').then(response =>
            {
                new ReturnApi(response, this);
                this.$events.fire('filter-reset');
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
  }
}
  </script>